const t = "Fase completata", o = "Torna a {buttonName}", n = "Continua a {buttonName}", e = {
  completedStep: t,
  backButton: o,
  nextButton: n
};
export {
  o as backButton,
  t as completedStep,
  e as default,
  n as nextButton
};
